import { render, staticRenderFns } from "./IndustryMarket.vue?vue&type=template&id=45a94222&scoped=true&"
import script from "./IndustryMarket.vue?vue&type=script&lang=js&"
export * from "./IndustryMarket.vue?vue&type=script&lang=js&"
import style0 from "./IndustryMarket.vue?vue&type=style&index=0&id=45a94222&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a94222",
  null
  
)

export default component.exports